import { ReactComponent as Mail } from "../../assets/mail.svg";
const Button = (props) => {
  return (
    <a className="w-full" href="mailto:jltdigisolutions@gmail.com">
      <button className="w-full p-[2px] rounded-full bg-gradient-to-r from-accent via-[#1C8D8E] to-[#2A5E6F]">
        <span className="flex flex-row items-center justify-center text-xs md:text-sm lg:text-xl w-auto text-white p-2 py-3 lg:p-4 rounded-full bg-bg-primary">
          {props.buttonTitle} <Mail />
        </span>
      </button>
    </a>
  );
};

export default Button;
